/** Display helpers for listing modal date pills — keeps YYYY-MM-DD API contract. */

export function formatListingDateInputValue(value) {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString().slice(0, 10);
}

/** Human-readable label for date pills (e.g. "Mar 4, 2026"). */
export function formatListingDateLabel(value) {
  const input = formatListingDateInputValue(value);
  if (!input) return '';
  const [year, month, day] = input.split('-').map(Number);
  const d = new Date(Date.UTC(year, month - 1, day));
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
}
